import axios from "axios";
import keycloak from "../keycloak";

export const axiosWithAuth = async (
  url: string,
  data: any,
  method: "get" | "post" | "put" | "delete" = "post",
  header?: any
) => {
  const token = localStorage.getItem("autoGraderToken");
  const user = localStorage.getItem("user");
  const headers = token
    ? { Authorization: `Bearer ${token}`, Email: user, ...header }
    : {};

  try {
    const response = await axios({
      method: method,
      url: url,
      data: data,
      headers: headers,
      params: method === "get" ? data.params : undefined,
    });

    return response;
  } catch (error: any) {
    console.error("API request failed:", error);
    if (error.status === 401) {
      localStorage.removeItem("autoGraderToken");
      localStorage.removeItem("user");
      keycloak?.logout();
    }
    throw error;
  }
};
